import { render, staticRenderFns } from "./SyncTimestampsStore.vue?vue&type=template&id=0040e0af&"
import script from "./SyncTimestampsStore.vue?vue&type=script&lang=js&"
export * from "./SyncTimestampsStore.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports